// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox__container-da9257 {
  --checkbox-offset: 0px;
  --checkbox-border-radius: 50%;
  width: 24px;
  height: 24px;
  margin-inline-end: 6px;
  padding: var(--checkbox-offset);
  box-sizing: border-box;
  cursor: pointer;
}

.Checkbox__disabled-ace4c9 {
  cursor: default;
}

.Checkbox__shape-square-c93395 {
  --checkbox-offset: 2px;
  --checkbox-border-radius: 4px;
}

.Checkbox__round-square-a22a2d {
  --checkbox-offset: 0px;
  --checkbox-border-radius: 50%;
}

.Checkbox__checkbox-wrapper-c28039 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: var(--checkbox-border-radius);
  border: 2px solid var(--base-60);
  box-sizing: border-box;
}

.Checkbox__selected-c97dd9 .Checkbox__checkbox-wrapper-c28039 {
  border: none;
  background-color: var(--brand-primary-40);
}

.Checkbox__minus-icon-d5cd8f {
  height: 2px;
  width: 10px;
  border-radius: 2px;
  background-color: var(--base-60);
}

.Checkbox__checkbox-a691e2 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Checkbox/Checkbox.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,6BAAA;EAEA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,sBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,sBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,gCAAA;EACA,sBAAA;AAAF;;AAGA;EACE,YAAA;EACA,yCAAA;AAAF;;AAGA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAAF","sourcesContent":[".container {\n  --checkbox-offset: 0px;\n  --checkbox-border-radius: 50%;\n\n  width: 24px;\n  height: 24px;\n  margin-inline-end: 6px;\n  padding: var(--checkbox-offset);\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.disabled {\n  cursor: default;\n}\n\n.shape-square {\n  --checkbox-offset: 2px;\n  --checkbox-border-radius: 4px;\n}\n\n.round-square {\n  --checkbox-offset: 0px;\n  --checkbox-border-radius: 50%;\n}\n\n.checkbox-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  border-radius: var(--checkbox-border-radius);\n  border: 2px solid var(--base-60);\n  box-sizing: border-box;\n}\n\n.selected .checkbox-wrapper {\n  border: none;\n  background-color: var(--brand-primary-40);\n}\n\n.minus-icon {\n  height: 2px;\n  width: 10px;\n  border-radius: 2px;\n  background-color: var(--base-60);\n}\n\n.checkbox {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Checkbox__container-da9257`,
	"disabled": `Checkbox__disabled-ace4c9`,
	"shape-square": `Checkbox__shape-square-c93395`,
	"shapeSquare": `Checkbox__shape-square-c93395`,
	"round-square": `Checkbox__round-square-a22a2d`,
	"roundSquare": `Checkbox__round-square-a22a2d`,
	"checkbox-wrapper": `Checkbox__checkbox-wrapper-c28039`,
	"checkboxWrapper": `Checkbox__checkbox-wrapper-c28039`,
	"selected": `Checkbox__selected-c97dd9`,
	"minus-icon": `Checkbox__minus-icon-d5cd8f`,
	"minusIcon": `Checkbox__minus-icon-d5cd8f`,
	"checkbox": `Checkbox__checkbox-a691e2`
};
module.exports = ___CSS_LOADER_EXPORT___;
